import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";

import {
  setCashSummary,
  clearCashSummary,
  setLoading
} from "../../store/slices/cash/cashSummarySlice";

import useApiErrorHandler from "../useApiErrorHandler";
import useLoading from "../useLoading";

import CashSummaryService from "../../services/cash/CashSummaryService";

export const useCashSummary = () => {
  const dispatch: AppDispatch = useDispatch();

  const { summary, loading } = useSelector(
    (state: RootState) => state.cashSummary
  );

  const { handle } = useApiErrorHandler();
  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  /**
   * 📊 Obtener resumen de caja por sesión
   */
  const getSummary = async (sessionId: number) => {
    try {
      showLoadingIndicator();
      dispatch(setLoading(true));

      const response = await CashSummaryService.getSummary(sessionId);

      if (response?.statusCode === 200) {
        dispatch(setCashSummary(response.data));
      }

      return response;
    } catch (error) {
      handle(error);
      return null;
    } finally {
      hideLoadingIndicator();
      dispatch(setLoading(false));
    }
  };

  const clear = () => {
    dispatch(clearCashSummary());
  };

  return {
    summary,
    loading,

    getSummary,
    clear
  };
};